// Минимальная транслитерация RU→EN для построения slug'а.
// Совпадает с именами файлов webp в /public/paintings (взяты оттуда).

const MAP = {
  а:'a',б:'b',в:'v',г:'g',д:'d',е:'e',ё:'yo',ж:'zh',з:'z',и:'i',й:'y',
  к:'k',л:'l',м:'m',н:'n',о:'o',п:'p',р:'r',с:'s',т:'t',у:'u',ф:'f',
  х:'kh',ц:'ts',ч:'ch',ш:'sh',щ:'shch',ъ:'',ы:'y',ь:'',э:'e',ю:'yu',я:'ya',
};

export function slugify(input) {
  if (!input) return '';
  const src = String(input).toLowerCase().trim();
  let out = '';
  for (const ch of src) {
    if (MAP[ch] !== undefined) out += MAP[ch];
    else if (/[a-z0-9]/.test(ch)) out += ch;
    else if (/\s|-|—|–|_/.test(ch)) out += '-';
    // остальное (пунктуация, «», ()) — отбрасываем
  }
  return out.replace(/-+/g, '-').replace(/^-|-$/g, '');
}

// Уникальный slug картины: берём имя webp-файла (/paintings/alisa.webp → alisa),
// fallback — транслитерация title[0]. Совпадает со slug'ами в supabase/seed.sql.
export function deriveArtworkSlug(p) {
  if (p?.img) {
    const m = p.img.match(/([^/]+)\.\w+$/);
    if (m) return m[1];
  }
  return slugify(p?.title?.[0] || '');
}
